import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import RunFrontier from "components/FrontierSliders/RunFrontier";

import * as runReducer from "containers/Run/reducer";
import * as projectReducer from "containers/Project/reducer";

class RunFrontierContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <RunFrontier {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  const activeSegment = ownProps.activeSegment
    ? ownProps.activeSegment
    : projectReducer.getActiveSegment(state, ownProps.projectId, ownProps.id);

  const isOverallSegment = projectReducer.getIsOverallSegment(state, ownProps.projectId, ownProps.id);

  let userThresholds;
  if (ownProps.isMonitoring) {
    userThresholds = projectReducer
      .getUserThresholds(state, ownProps.projectId, ownProps.userId, ownProps.modelGroups)
      .filter((threshold) => isOverallSegment || threshold.runId === ownProps.id);
  }

  return {
    capModels: runReducer.getFrontier(state, ownProps.id),

    capValue: projectReducer.getCapValue(state, ownProps.projectId, ownProps.id),
    activeSegment: activeSegment,
    isOverallSegment: isOverallSegment,
    userThresholds: userThresholds
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RunFrontierContainer);
